import { render, staticRenderFns } from "./FixedAmount.vue?vue&type=template&id=fe97a37e&scoped=true&"
import script from "./FixedAmount.vue?vue&type=script&lang=js&"
export * from "./FixedAmount.vue?vue&type=script&lang=js&"
import style0 from "./style.less?vue&type=style&index=0&id=fe97a37e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe97a37e",
  null
  
)

export default component.exports